export const ROUTES = {
  HOME: "/",
  SEARCH: "/explore",
  PROFILE: "/my-space",
  SHOWS: "/shows",
  MOVIES: "/movies",
  SPORTS: "/sports",
  CATEGORIES: "/categories",
  MOVIE_DETAILS: "/detail/:id",
  SUBSCRIBE: "/detail/:id/watch",
};
